// extracted by mini-css-extract-plugin
module.exports = {"instagramEmbed":"instagram-player_instagramEmbed__dQ1fG"};